import gql from "graphql-tag";

export const SAVINGS_GET_CALCULATION_DATA = gql`
	query CalculationData(
		$comparisonId: UUID!
	) {
		calculationData(comparisonId: $comparisonId)
	}
`;
